module.exports = __webpack_public_path__ + "img/121.8.65220993.png";